import { render, staticRenderFns } from "./ehc-editor.vue?vue&type=template&id=d2b0f888"
import script from "./ehc-editor.vue?vue&type=script&lang=js"
export * from "./ehc-editor.vue?vue&type=script&lang=js"
import style0 from "./ehc-editor.vue?vue&type=style&index=0&id=d2b0f888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports